<script>

    import Spinner from './spinner.svelte'

    export let loading = false

</script>

<Spinner {loading} />

{#if !loading}
    <div class="table-container">
        <table class="table is-fullwidth">
            <slot></slot>
        </table>
    </div>
{/if}